import { PPLPickupPoint } from 'skladon-types';

export const formatData = (data: PPLPickupPoint[]) => {
    return data.map((item) => ({
        label: `${item.street} , ${item.city}, ${item.zipCode}, ${item.name}`,
        value: item.accessPointCode
    }));
};
